var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var API_URL = '';
var proxiedUrls = {
    '/api': "".concat(API_URL, "/api"),
};
/**
 * Checks the front of the user supplied URL and changes the font of it to use our API_HOST
 * If the supplied URL doesn't match any of our proxies, return the provided URL
 */
function _replaceUrl(userUrl) {
    var proxy = Object.keys(proxiedUrls).find(function (key) {
        if (userUrl.startsWith(key))
            return true;
        return false;
    });
    if (!proxy)
        return userUrl;
    return userUrl.replace(proxy, proxiedUrls[proxy]);
}
function _handleResponse(res) {
    // unfulfilled promise & error handling for non json response bodies
    var body = res.json().catch(function (err) { return _handleNonJsonResponse(err, res); });
    if (res.ok)
        return body;
    return body.then(function (err) {
        throw err;
    });
}
function _handleNonJsonResponse(err, res) {
    if (!res.ok || res.status >= 400)
        throw err;
    if (err instanceof SyntaxError)
        return res;
    throw err;
}
function _handleError(err) {
    // TODO report error
    console.error(err);
    throw err;
}
function _fetchWrapper(url, request) {
    return fetch(url, request).then(_handleResponse).catch(_handleError);
}
function get(url, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var proxy, request;
        return __generator(this, function (_a) {
            proxy = _replaceUrl(url);
            request = __assign({ method: 'GET', headers: { 'accept': 'application/json' } }, options);
            return [2 /*return*/, _fetchWrapper(proxy, request)];
        });
    });
}
var RequestService = {
    get: get,
};
export default RequestService;
